module.exports = __webpack_public_path__ + "static/media/Knewave.8b915a71.svg";